import { IconElement } from '../../../types/IconElement';
import { memo } from 'react';
import classes from 'classnames';
import styles from './Title.module.scss';

export type TitleProps = {
  icon?: IconElement;
  text: string;
  mobileText?: string;
  forceColumn?: boolean;
  className?: string;
  iconClassName?: string;
  dataTest?: string;
};

export default memo(function Title({
  icon,
  text,
  mobileText = undefined,
  forceColumn = false,
  className,
  iconClassName,
  dataTest = 'title',
}: TitleProps) {
  return (
    <div
      className={classes(
        styles.container,
        className,

        forceColumn && styles['container-force-column'],
      )}
      data-test={dataTest}
    >
      {icon && (
        <div className={classes(styles.icon, iconClassName)}>{icon}</div>
      )}

      <div
        className={classes(styles.text, mobileText && styles['hide-on-mobile'])}
        dangerouslySetInnerHTML={{ __html: text }}
      />

      {mobileText && (
        <div
          className={classes(styles.text, styles['hide-on-desktop'])}
          dangerouslySetInnerHTML={{ __html: mobileText }}
        />
      )}
    </div>
  );
});
